// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"50318db3","568":"ac705439","919":"01ff25a9"}[chunkId] + ".chunk.js";
};